<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "OutputShipping" });
import "tailwindcss/tailwind.css";
import { t } from "svelte-i18n";
export let option;
</script>

{ $t(`resource.auction.properties.shipping.options.${ option }.label`) }